// resolvePanel.js — the drop-down under a held / deleted-on-phone pill, as a
// pure state machine so the row can never show a stale mix of loading, error
// and busy. Pure: no React, no fetch. The row drives it and renders it.
//
//   null                          closed
//   { kind, loading, fields, error, busy }
//     kind     'held' | 'phone-deleted'
//     loading  fetching the diff (held only)
//     fields   [{ field, key, phone, app }] from contacts-held
//     error    inline message, or null
//     busy     the choice in flight ('phone' | 'app' | 'restore'), or null

export const BUTTONS = {
  held: [{ choice: 'phone', label: 'Keep phone' }, { choice: 'app', label: 'Keep app' }],
  'phone-deleted': [{ choice: 'restore', label: 'Put back on phone' }],
};

/** Which pill kinds open a panel on tap. */
export const RESOLVABLE = new Set(Object.keys(BUTTONS));

export function panelOpen(kind) {
  if (!RESOLVABLE.has(kind)) return null;
  return { kind, loading: kind === 'held', fields: [], error: null, busy: null };
}
export const panelLoaded = (p, fields) => (p ? { ...p, loading: false, fields: Array.isArray(fields) ? fields : [], error: null } : p);
export const panelFailed = (p, message) => (p ? { ...p, loading: false, busy: null, error: message || 'Something went wrong' } : p);
export const panelBusy = (p, choice) => (p && !p.busy ? { ...p, busy: choice, error: null } : p);
export const panelDone = () => null;

/** The words under a resolve error: a 409 means the row moved on; anything else is the message. */
export function resolveErrorText(status, body) {
  if (status === 409) return `This contact is no longer ${body?.state === 'phone-deleted' ? 'held' : body?.state || 'in that state'} — reload to see its current state.`;
  return body?.error || 'Could not resolve — try again.';
}
